import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { store } from "./store/store";
import VueCookies from "vue-cookies";
import "@maersk-global/mds-components-core";
import mcModel from "@maersk-global/mds-vue-mc-model";

import './assets/css/style.css';

Vue.use(VueCookies);

Vue.$cookies.config("av");

Vue.config.productionTip = false
Vue.directive("mc-model", mcModel);
Vue.config.ignoredElements = [/^mc-/];
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
